import { colors, typography } from '@mehilainen/mds-tokens';
import { createTheme } from '@mui/material';
import pick from 'lodash/pick';
import { getThemeAccordion } from './theme/components/accordion';
import { getThemeAlert } from './theme/components/alert';
import { getThemeAutocomplete } from './theme/components/autocomplete';
import { getThemeBadge } from './theme/components/badge';
import { getThemeButtons } from './theme/components/buttons';
import { getThemeChip } from './theme/components/chip';
import { getThemeFormElements } from './theme/components/form';
import { getThemeLink } from './theme/components/link';
import { getThemePagination } from './theme/components/pagination';
import { getThemeSelect } from './theme/components/select';
import { getThemeSelections } from './theme/components/selections';
import { getThemeSpinner } from './theme/components/spinner';
import { getThemeTabs } from './theme/components/tabs';
import { getThemeTimeline } from './theme/components/timeline';
import { getThemeToggleButton } from './theme/components/togglebutton';
import { customerTokens } from './theme-customer-tokens';
import { professionalTokens } from './theme-professional-tokens';
const getTheme = (tokens) => ({
    palette: {
        primary: {
            main: colors.Primary500,
            dark: colors.Primary600,
        },
        action: {
            disabled: colors.White,
            disabledBackground: colors.Gray600,
        },
        error: {
            main: colors.Error500,
            dark: colors.Error600,
        },
    },
    typography: {
        fontFamily: 'Gotham SSm A, Gotham SSm B, Verdana, Geneva, sans-serif',
        fontSize: 13,
        fontWeightBold: 700,
        fontWeightMedium: 500,
        fontWeightRegular: 400,
        h1: Object.assign({}, typography.textStyle800BoldHeightM),
        h2: Object.assign({}, typography.textStyle700MediumHeightM),
        h3: Object.assign({}, typography.textStyle600MediumHeightM),
        h4: Object.assign({}, typography.textStyle500MediumHeightM),
        h5: Object.assign({}, typography.textStyle450MediumHeightL),
        h6: Object.assign({}, typography.textStyle400MediumHeightL),
        h6Uppercase: Object.assign(Object.assign({}, typography.textStyle400MediumHeightMUppercase), { textTransform: 'uppercase' }),
        body1: Object.assign(Object.assign({}, typography.textStyle400RegularHeightL), { fontWeight: 400 }),
        body2: Object.assign(Object.assign({}, typography.textStyle300RegularHeightL), { fontWeight: 400 }),
        button: Object.assign({}, typography.textStyle400MediumHeightS),
    },
    components: getThemeOptionsComponents(tokens),
});
// NOTE: Keep this as not typed return value since we want to keep info what components we actually have in our theme
const getThemeOptionsComponents = (tokens) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, getThemeAccordion(tokens)), getThemeAlert(tokens)), getThemeAutocomplete(tokens)), getThemeButtons(tokens)), getThemeChip(tokens)), getThemeFormElements(tokens)), getThemePagination(tokens)), getThemeSelections(tokens)), getThemeSpinner(tokens)), getThemeTabs(tokens)), getThemeToggleButton(tokens)), getThemeSelect(tokens)), getThemeBadge(tokens)), getThemeLink(tokens)), getThemeTimeline(tokens)));
export const customerThemeOptions = getTheme(customerTokens);
export const customerTheme = createTheme(customerThemeOptions);
export const professionalThemeOptions = getTheme(professionalTokens);
export const professionalTheme = createTheme(professionalThemeOptions);
export const getPartialCustomerTheme = (...pickedKeys) => createTheme(Object.assign(Object.assign({}, customerThemeOptions), { components: pick(customerThemeOptions.components, pickedKeys) }));
export const getPartialProfessionalTheme = (...pickedKeys) => createTheme(Object.assign(Object.assign({}, professionalThemeOptions), { components: pick(professionalThemeOptions.components, pickedKeys) }));
